import React from "react";
import { Gantt, ViewMode } from 'gantt-task-react';
import "gantt-task-react/dist/index.css";
import "./ReportsGantt.css";
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import IconButton from '@mui/material/IconButton';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Stack from '@mui/material/Stack';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import TodayIcon from '@mui/icons-material/Today';
import { GlobalContext } from "../../Context/GlobalContext";
import ReportsProcessCompChart from '../ReportsProcessCompChart/ReportsProcessCompChart';
import { getActiveProcesses } from "../../Components/RMCActiveProcess/RMCActiveProcess";
import {subtractWorkingDays } from "../../Utils/date.util.js";



//$$ This function compares subprocess labels with active projects Id
const BelongsToActiveProject = (label, array) => {
    console.log("label:::::",label);
    console.log("array:::::",array);
    return array.some(item => item.id === label);
};

// --- STYLE HELPERS ---
const getTaskStyles = (type, isLate = false, isCurrent = false) => {
    if (type === 'project') {
        return {
            backgroundColor: '#4a4440',
            progressColor: '#4a4440',
            barBackgroundColor: '#4a4440',
            backgroundSelectedColor: '#635a54',
            progressSelectedColor: '#635a54'
        };
    }
    //var colorCode = '#ffbcbc';

    let codebackgroundColor = '#ffb3b3';
    let codeprogressColor = '#ffb3b3';
    let codebackgroundSelectedColor = '#ffbcbc';
    let codeprogressSelectedColor = '#ffbcbc';

    if (isLate)
    {
        codebackgroundColor = '#ffb3b3';
        codeprogressColor = '#ffb3b3';
        codebackgroundSelectedColor = '#ffbcbc';
        codeprogressSelectedColor = '#ffbcbc';
    }
    else
    {
        codebackgroundColor = '#d1d1d1';
        codeprogressColor = '#d1d1d1';
        codebackgroundSelectedColor = '#bcbcbc';
        codeprogressSelectedColor = '#bcbcbc';
    }
    if (isCurrent)
    {
        codebackgroundColor = '#4CAF50';
        codeprogressColor = '#4CAF50';
        codebackgroundSelectedColor = '#63CF63';
        codeprogressSelectedColor = '#63CF63';
    }

   return {
       backgroundColor: codebackgroundColor,
       progressColor: codeprogressColor,
       backgroundSelectedColor: codebackgroundSelectedColor,
       progressSelectedColor: codeprogressSelectedColor
   };
};

const parseISOString = (dateString) => {
    if (!dateString) return new Date();
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day);
};

function hslToHex(typeId) {
  const cycleValue = ((typeId - 1) % 25) + 1;
  const h = cycleValue * (360 / 25);
  const s = 70 / 100;
  const l = 50 / 100;

  const a = s * Math.min(l, 1 - l);
  const f = n => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color).toString(16).padStart(2, '0');
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}


/**
 * Maps flat backend data into a Project-Task hierarchy.
 */
const MapDataToGanttTasks = (flatData, searchTerm, searchTermProcess, searchTermType, onlyActives) => {

    let activeProcesses = getActiveProcesses();
     //const [selectActive, setSelectActive] = React.useState(false);
    //console.log("searchTermProcess:", searchTermProcess);
    //console.log("flatData:", flatData);

    if (!Array.isArray(flatData)) return [];

    const projectsMap = {};

    const typeIdToTaskIdMap = {};

    const typeIdDurationMediaMap = {};

    var isCompleted = true;

    flatData.forEach((row) => {

        //console.log("row:", row);

        if (!row.endDate) return;

       //$$ filtering projects by employee target project
       if (searchTermProcess != "" && (row.targetCenter != searchTermProcess))
       {
           console.log("searchTermProcess NOT null");
           return;
       }

        //const taskStartDate = parseISOString(row.endDate);
        //if (isNaN(taskStartDate.getTime())) return;

        const taskEndDate = parseISOString(row.endDate);
        if (isNaN(taskEndDate.getTime())) return;

        const actualDur = Number(row.duration) || 0;
        const mediaDur = Number(row.defaultDuration) || 0;
        const visualDuration = actualDur > 0 ? actualDur : 1;

        const taskStartDate = subtractWorkingDays(taskEndDate, visualDuration);

        //$$ Extremo exclusivo, solo para pintar: asi la barra cubre el ultimo dia
        const taskBarEndDate = new Date(taskEndDate);
        taskBarEndDate.setDate(taskBarEndDate.getDate() + 1);


        //const taskEndDate = new Date(taskStartDate);
        //taskEndDate.setDate(taskStartDate.getDate() + visualDuration);

        const prefix = row.process === "Alta" ? "AL" : row.process === "Baja" ? "BA" : row.process?.substring(0, 2).toUpperCase() || "PR";
        const projectDisplayName = `${prefix}${row.label} ${row.targetEmployee}`;
        const pId = `P_${projectDisplayName}`;

        const now = new Date();
        const isLate = ((row.statusId !== 3) && (taskEndDate < now)) || (row.schedule < 0);

        //$$ Adding current status task
        const isCurrent = (row.statusId == 2);

        //$$ Adding pending task. We need it for detect incompleted project
        if(row.statusId !== 3)
        {
            isCompleted = false;
        }

        const department = row.department ? String(row.department).toLowerCase() : "";
        //const center = row.responsibleCenter ? String(row.responsibleCenter).toLowerCase() : "";
        const center = row.targetCenter ? String(row.targetCenter) : "";
        const pLabel = row.label ? String(row.label) : "";
        const pName = row.process ? String(row.label) : "";

         //Check Active projects
         var isActiveProject = false;
         isActiveProject = BelongsToActiveProject (row.label, activeProcesses);

        //if ( isActiveProject == true ) //(true)
        if (!onlyActives || isActiveProject)
        {

        console.log(`isActiveProject: ${isActiveProject} | row.label: ${row.label}`);

        if (!projectsMap[pId]) {
            projectsMap[pId] = {
                id: pId,
                name: projectDisplayName,
                start: new Date(taskStartDate),
                end: new Date(taskBarEndDate),
                progress: 0,
                type: 'project',
                hideChildren: true,
                styles: getTaskStyles('project'),
                completed: isCompleted,
                subtasks: []
            };
            typeIdToTaskIdMap[pId] = {};

            console.log("projectsMap[pId]:", projectsMap[pId]);
        }

        const taskId = `T_${row.id}`;

        if (row.typeId) {
            typeIdToTaskIdMap[pId][row.typeId] = taskId;

            if (!typeIdDurationMediaMap[row.typeId]) {
                typeIdDurationMediaMap[row.typeId] = {
                    type: row.typeId,
                    durations: []
                }
            }

            typeIdDurationMediaMap[row.typeId].durations.push(actualDur);
        }

        projectsMap[pId].subtasks.push({
            id: taskId,
            name: row.name || "Subproceso",
            start: new Date(taskStartDate),
            end: new Date(taskBarEndDate),
            progress: (row.statusId - 1) * 50,
            type: 'task',
            project: pId,
            tempParentTypeIds: row.parentSubprocessIds || [],
            styles: getTaskStyles('task', isLate, isCurrent),
            fontSize: '12px',
            customData: {
                actual: actualDur,
                media: mediaDur,
                color: hslToHex(row.typeId),
                //filteredShow: (department.includes(searchTerm) || center.includes(searchTerm)) && (pLabel.includes(searchTermProcess) || pName.includes(searchTermProcess)),
                filteredShow: department.includes(searchTerm), // || center.includes(searchTermProcess),
                typeTask: row.typeId
            }
        });
    }

    //console.log("projectsMap[pId]:", projectsMap);

    });



    const finalMedias = Object.values(typeIdDurationMediaMap).reduce((acc, item) => {
        const sum = item.durations.reduce((a, b) => a + b, 0);
        const average = item.durations.length > 0 ? sum / item.durations.length : 0;

        acc[item.type] = average;
        return acc;
    }, {});

    const finalGanttTasks = [];
    Object.values(projectsMap).forEach((proj) => {
        const pId = proj.id;

        proj.subtasks.forEach(task => {
            if (task.tempParentTypeIds && task.tempParentTypeIds.length > 0) {

                const dependencies = task.tempParentTypeIds
                    .map(typeId => typeIdToTaskIdMap[pId][typeId])
                    .filter(parentId => {
                        const isFound = !!parentId;
                        const isNotSelf = parentId !== task.id;
                        return isFound && isNotSelf;
                    });

                if (dependencies.length > 0) {
                    task.dependencies = dependencies;
                }
            }

            delete task.tempParentTypeIds;

            const typeId = task.customData?.typeTask;

            if (typeId && finalMedias[typeId] !== undefined) {
                if (!task.customData) task.customData = {};
                task.customData.media = finalMedias[typeId];
            }
        });

        const sortedSubtasks = proj.subtasks.sort((a, b) => a.start.getTime() - b.start.getTime());
        if (sortedSubtasks.length > 0) {
            proj.start = new Date(sortedSubtasks[0].start);
            const lastTask = [...sortedSubtasks].sort((a, b) => b.end.getTime() - a.end.getTime())[0];
            proj.end = new Date(lastTask.end);
            finalGanttTasks.push(proj, ...sortedSubtasks);
        }
    });

    return finalGanttTasks;
};

const ReportsGantt = ({ data, isLoading, error, searchTerm , searchTermProcess, searchTermType }) => {
    const { setAlertBarSeverity, setAlertBarMessage, setAlertBarOpen } = React.useContext(GlobalContext);

    const [tasks, setTasks] = React.useState(null);
    const [view, setView] = React.useState(ViewMode.Day);
    const [currentViewDate, setCurrentViewDate] = React.useState(new Date());
    const [selectedProjectId, setSelectedProjectId] = React.useState(null);
    const [onlyActives, setOnlyActives] = React.useState(true);

    React.useEffect(() => {
        if (!isLoading) {
            if (error) {
                setAlertBarSeverity("error");
                setAlertBarMessage(error);
                setAlertBarOpen(true);
            } else if (data && Array.isArray(data) && data.length > 0) {
                const transformedTasks = MapDataToGanttTasks(data, searchTerm , searchTermProcess, searchTermType, onlyActives);
                if (transformedTasks.length > 0) {
                    setTasks(transformedTasks);
                    const firstProject = transformedTasks.find(t => t.type === 'project');
                    if (firstProject) {
                        setSelectedProjectId(firstProject.id);
                        setCurrentViewDate(new Date(firstProject.start));
                    }
                } else {
                    setTasks([]);
                }
            } else if (data) {
                setTasks([]);
            }
        }
    }, [isLoading, error, data, searchTerm, setAlertBarMessage, setAlertBarOpen, setAlertBarSeverity , searchTermProcess, onlyActives]);

    const handleViewChange = (event, nextView) => {
        if (nextView !== null) setView(nextView);
    };

    const handleActivesChange = () => {
            setOnlyActives((prev) => !prev);
        };

    const handleTaskClick = (task) => {
        if (task.type === 'project') {
            setSelectedProjectId(task.id);
            setTasks((prevTasks) =>
                prevTasks.map((t) =>
                    t.id === task.id ? { ...t, hideChildren: !t.hideChildren } : t
                )
            );
        } else if (task.project) {
            setSelectedProjectId(task.project);
        }
    };

    const handleNavigation = (direction) => {
        const offset = view === ViewMode.Day ? 7 : 30;
        const nextDate = new Date(currentViewDate);
        nextDate.setDate(nextDate.getDate() + (direction * offset));
        setCurrentViewDate(nextDate);
    };

    const handleToday = () => {
        setCurrentViewDate(new Date());
    };

    const visibleTasks = React.useMemo(() => {
        if (!tasks || tasks.length === 0) return [];
        const collapsedProjectIds = tasks
            .filter(t => t.type === 'project' && t.hideChildren)
            .map(t => t.id);

        return tasks.filter(t => {
            if (t.type === 'project') return true;
            return !collapsedProjectIds.includes(t.project);
        });
    }, [tasks]);


    const dynamicChartData = React.useMemo(() => {
        if (!tasks || !selectedProjectId) return [];

        const projectSubTasks = tasks.filter(t =>
            t.type === 'task' &&
            t.project === selectedProjectId &&
            //t.project === varProject &&
            t.customData?.filteredShow
        );

        //console.log("t          :", )


        console.log("projectSubTasks:", projectSubTasks);
        console.log("selectedProjectId:", selectedProjectId);

        return projectSubTasks.map(task => ({
            name: task.name,
            media: task.customData?.media,
            actual: task.customData?.actual,
            color: task.customData?.color
        }));
    }, [tasks, selectedProjectId]);

    return (
        <Paper sx={{ minWidth: 702, borderRadius: "23px", height: "auto", padding: "20px", backgroundColor: "#fcfcfc", boxShadow: '3px 11px 7px -6px rgba(161, 156, 161, 1)' }}>
            <Grid container spacing={2} sx={{ height: '100%' }}>
                <Grid size={8} sx={{ borderRight: '1px solid #e0e0e0', pr: 2, display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <IconButton onClick={() => handleNavigation(-1)} size="small" sx={{ border: '1px solid #eee' }}>
                            <ArrowBackIosNewIcon fontSize="small" sx={{ color: '#ccc' }} />
                        </IconButton>
                        <Stack direction="row" spacing={2} alignItems="center">
                            <ToggleButtonGroup value={view} exclusive onChange={handleViewChange} size="small" sx={{ height: '32px' }}>
                                <ToggleButton value={ViewMode.Day} sx={{ textTransform: 'none', px: 2, fontWeight: 500 }}>Days</ToggleButton>
                                <ToggleButton value={ViewMode.Week} sx={{ textTransform: 'none', px: 2, fontWeight: 500 }}>Weeks</ToggleButton>
                                 <ToggleButton selected={onlyActives} onChange={handleActivesChange} value="actives"  size="small"
                                                                                                 sx={{ textTransform: 'none', px: 2, fontWeight: 500, height: '32px' }}>Actives</ToggleButton>
                          </ToggleButtonGroup>
                            <IconButton onClick={handleToday} size="small">
                                <TodayIcon fontSize="small" sx={{ color: '#bdbdbd' }} />
                            </IconButton>
                        </Stack>
                        <IconButton onClick={() => handleNavigation(1)} size="small" sx={{ border: '1px solid #eee' }}>
                            <ArrowForwardIosIcon fontSize="small" sx={{ color: '#ccc' }} />
                        </IconButton>
                    </Box>

                    {isLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexGrow: 1 }}><CircularProgress /></Box>
                    ) : (!tasks || tasks.length === 0) ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexGrow: 1 }}>
                            <Typography color="textSecondary">No valid subprocess data available</Typography>
                        </Box>
                    ) : (
                        <Box className="custom-gantt-container" sx={{ overflow: 'auto', flexGrow: 1 }}>
                            <Gantt
                                tasks={visibleTasks}
                                viewMode={view}
                                viewDate={currentViewDate}
                                onClick={handleTaskClick}
                                listCellWidth=""
                                columnWidth={view === ViewMode.Day ? 60 : 120}
                                barFill={75}
                                barCornerRadius={15}
                                rowHeight={68}
                                locale="es-ES"
                                headerHeight={50}
                                fontSize="14px"
                                fontFamily="Roboto, sans-serif"
                            />
                        </Box>
                    )}
                </Grid>

                <Grid size={4} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <Typography variant="h6" color="textSecondary" sx={{ fontWeight: '500', mb: 2 }}>
                        Days - Average vs actual
                    </Typography>
                    <Box sx={{ width: '100%', height: '400px', backgroundColor: '#fff', borderRadius: '30px', p: 2 }}>
                        <ReportsProcessCompChart data={dynamicChartData} />
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default ReportsGantt;